"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMultiLine = exports.renderLine = exports.MIN_STROKE_WIDTH = void 0;
var color_library_wrappers_1 = require("../../../../../common/color_library_wrappers");
var canvas_1 = require("../../../../../renderers/canvas");
exports.MIN_STROKE_WIDTH = 0.001;
function renderLine(ctx, line, stroke) {
    renderMultiLine(ctx, [line], stroke);
}
exports.renderLine = renderLine;
function renderMultiLine(ctx, lines, stroke) {
    if (stroke.width < exports.MIN_STROKE_WIDTH) {
        return;
    }
    canvas_1.withContext(ctx, function (ctx) {
        var lineLength = lines.length;
        if (lineLength === 0) {
            return;
        }
        ctx.strokeStyle = color_library_wrappers_1.RGBtoString(stroke.color);
        ctx.lineJoin = 'round';
        ctx.lineWidth = stroke.width;
        if (stroke.dash) {
            ctx.setLineDash(stroke.dash);
        }
        ctx.beginPath();
        if (isStringArray(lines)) {
            for (var i = 0; i < lineLength; i++) {
                var path = lines[i];
                ctx.stroke(new Path2D(path));
            }
            return;
        }
        for (var i = 0; i < lineLength; i++) {
            var _a = lines[i], x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2;
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
        }
        ctx.stroke();
    });
}
exports.renderMultiLine = renderMultiLine;
function isStringArray(lines) {
    return typeof lines[0] === 'string';
}
//# sourceMappingURL=line.js.map